import React, { useState, useEffect } from "react";
import * as styles from "./ContactForm.module.scss";
import axios from "axios";
import { getAllCategoriesManual } from "../../../services/Categories/getAllCategoriesManual";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    selectedOption: "",
    name: "",
    localidad: "",
    provincia: "",
    telefono: "",
    email: "",
    message: "",
    razonSocial: "",
    cuit: "",
    numeroSerie: "",
    codigoProducto: "",
    tipoProducto: "",
    imagenes: [],
    cv: null,
  });

  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    getAllCategoriesManual()
      .then((receivedCategories) => {
        if (receivedCategories && receivedCategories.length > 0) {
          setCategories(receivedCategories);
        } else {
          console.log("No se recibieron categorías");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const handleFileChange = (e) => {
    const MAX_FILE_SIZE = 2097152; // 2 MB
    const SUPPORTED_FILE_EXTENSIONS = [
      ".pdf",
      ".doc",
      ".docx",
      ".jpg",
      ".jpeg",
      ".png",
    ];
    const files = Array.from(e.target.files);
    const validFiles = [];

    files.forEach((file) => {
      const fileName = file.name;
      const fileExtension = fileName.slice(
        ((fileName.lastIndexOf(".") - 1) >>> 0) + 2
      );

      if (file.size > MAX_FILE_SIZE) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          imagenes: "Uno o más archivos son demasiado grandes.",
        }));
      } else if (
        !SUPPORTED_FILE_EXTENSIONS.includes("." + fileExtension.toLowerCase())
      ) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          imagenes:
            "Uno o más archivos tienen un tipo no admitido. Debe ser PDF, doc, jpg, jpeg o png.",
        }));
      } else {
        validFiles.push(file);
      }
    });

    if (validFiles.length > 5) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        imagenes: "No puede subir más de 5 imágenes.",
      }));
    } else {
      setFormData({
        ...formData,
        imagenes: validFiles,
      });
      setErrors((prevErrors) => ({
        ...prevErrors,
        imagenes: "",
      }));
    }
  };

  const handleCvChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData({
        ...formData,
        cv: file,
      });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleCategoryChange = (category) => {
    setSelectedCategory(category);
    setFormData((prevFormData) => ({
      ...prevFormData,
      tipoProducto: category,
    }));
  };

  const validateForm = () => {
    const requiredFields = {
      general: ["selectedOption", "name", "localidad", "provincia", "telefono", "email", "message"

      ],
      "Recursos humanos": ["cv"],
      "Compras mayoristas": ["razonSocial", "cuit"],
      "Servicio Técnico": ["numeroSerie", "codigoProducto", "tipoProducto"],
      "Atencion al cliente": ["numeroSerie", "codigoProducto", "tipoProducto"],
    };
  
    let missingFields = [];
  
    // Validación de campos generales
    requiredFields.general.forEach(field => {
      if (!formData[field]) {
        missingFields.push(campoToLabel(field));
      }
    });
  
    // Validación de campos específicos según el área seleccionada
    const selectedArea = formData.selectedOption;
    if (requiredFields[selectedArea]) {
      requiredFields[selectedArea].forEach(field => {
        if (!formData[field]) {
          missingFields.push(campoToLabel(field));
        }
      });
    }
  
    if (missingFields.length > 0) {
      alert(`Faltan completar los siguientes campos:\n- ${missingFields.join("\n- ")}`);
      setIsSubmitting(false);
      return false;
    }
  
    return true;
  };
  
  // Función auxiliar para convertir nombres de campo en etiquetas de texto
  const campoToLabel = (field) => {
    const labels = {
      selectedOption: "Área",
      name: "Nombre y apellido",
      localidad: "Localidad",
      provincia: "Provincia",
      telefono: "Teléfono",
      email: "Correo electrónico",
      cv: "CV",
      razonSocial: "Razón social",
      cuit: "CUIT",
      numeroSerie: "Número de serie",
      codigoProducto: "Código de producto",
      tipoProducto: "Tipo de producto",
      message: "Mensaje"
    };
    return labels[field] || field;
  };
  

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    if (!validateForm()) return;
  
    const formDataToSend = new FormData();
  
    // Campos comunes a todas las áreas
    const commonFields = ["selectedOption", "name", "localidad", "provincia", "telefono", "email", "message"];
    commonFields.forEach(field => formDataToSend.append(field, formData[field]));
  
    // Campos específicos para cada área
    const areaSpecificFields = {
      "Recursos humanos": [["cv", formData.cv]],
      "Compras mayoristas": [["razonSocial", formData.razonSocial], ["cuit", formData.cuit]],
      "Servicio Técnico": [
        ["numeroSerie", formData.numeroSerie],
        ["codigoProducto", formData.codigoProducto],
        ["tipoProducto", formData.tipoProducto],
      ],
      "Atencion al cliente": [
        ["numeroSerie", formData.numeroSerie],
        ["codigoProducto", formData.codigoProducto],
        ["tipoProducto", formData.tipoProducto],
      ],
    };
  
    // Agregar los campos específicos del área seleccionada
    const selectedArea = formData.selectedOption;
    if (areaSpecificFields[selectedArea]) {
      areaSpecificFields[selectedArea].forEach(([field, value]) => {
        if (value) formDataToSend.append(field, value);
      });
    }
  
    // Agregar imágenes si existen y el área es "Servicio Técnico" o "Atencion al cliente"
    if (["Servicio Técnico", "Atencion al cliente"].includes(selectedArea) && formData.imagenes) {
      formData.imagenes.forEach((imagen, index) => {
        formDataToSend.append(`imagen${index + 1}`, imagen);
      });
    }
  
    try {
      const response = await axios.post(`${process.env.GATSBY_API_URL}/api/contact/send-mail`, formDataToSend, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
  
      const data = response.data;
      console.log("Respuesta del servidor:", data);
      alert("El formulario se ha enviado correctamente.");
      setIsSuccess(true);
      setTimeout(() => {
        setIsSuccess(false);
        setIsSubmitting(false);
        setFormData({
          selectedOption: "",
          name: "",
          localidad: "",
          provincia: "",
          telefono: "",
          email: "",
          message: "",
          razonSocial: "",
          cuit: "",
          numeroSerie: "",
          codigoProducto: "",
          tipoProducto: "",
          imagenes: [],
          cv: null,
        });
      }, 2000);
    } catch (error) {
      console.error("Error al enviar el formulario:", error);
      alert("Ha ocurrido un error al enviar el formulario. Por favor, inténtelo de nuevo más tarde.");
      setIsSubmitting(false);
    }
  };  

  return (
    <section className={styles.SectionForm}>
      <div className={styles.FormContainer}>
        <h2 className={styles.title}>Formulario de Contacto</h2>
        <form onSubmit={handleSubmit}>
          <div className={styles.box}>
            <label>Seleccione un área*</label>
            <select
              name="selectedOption"
              value={formData.selectedOption}
              onChange={handleChange}
            >
              <option value="">Seleccione un área</option>
              <option value="Compras mayoristas">Compras mayoristas</option>
              <option value="Recursos humanos">Recursos Humanos</option>
              <option value="Atencion al cliente">Atención al cliente</option>
              <option value="Propuesta de Mkt">Propuesta de Marketing</option>
              <option value="Servicio Técnico">Servicio Técnico</option>
            </select>
          </div>
          {formData.selectedOption === "Compras mayoristas" && (
            <>
              <div className={styles.box}>
                <label>Razón Social</label>
                <input
                  type="text"
                  name="razonSocial"
                  value={formData.razonSocial}
                  onChange={handleChange}
                />
              </div>
              <div className={styles.box}>
                <label>CUIT</label>
                <input
                  type="text"
                  name="cuit"
                  value={formData.cuit}
                  onChange={handleChange}
                />
              </div>
            </>
          )}
          {["Servicio Técnico", "Atencion al cliente"].includes(
            formData.selectedOption
          ) && (
            <>
              <div className={styles.box}>
                <label>Número de Serie</label>
                <input
                  type="text"
                  name="numeroSerie"
                  value={formData.numeroSerie}
                  onChange={handleChange}
                />
              </div>
              <div className={styles.box}>
                <label>Código de Producto</label>
                <input
                  type="text"
                  name="codigoProducto"
                  value={formData.codigoProducto}
                  onChange={handleChange}
                  placeholder="Ejemplo: PE-HG26M"
                />
              </div>
              <div className={styles.box}>
                <label>
                  <p>Categorías</p>
                </label>
                <select
                  value={selectedCategory}
                  onChange={(e) => handleCategoryChange(e.target.value)}
                  style={{
                    cursor: "pointer",
                  }}
                >
                  <option value="-">-</option>
                  {categories?.map((category) => (
                    <option key={category.id} value={category.name}>
                      {category.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className={styles.DobleInput}>
                <label>Fotos (máximo 5, 5 MB cada una)</label>
                <div className={styles.customFile}>
                  <label className={styles.customFileLabel}>
                    <input
                      type="file"
                      className={styles.customFileInput}
                      name="imagenes"
                      accept="image/*"
                      multiple
                      onChange={handleFileChange}
                    />
                    {formData.imagenes.length === 0 ? <p>Adjuntar</p> : <p>{formData.imagenes.length} {formData.imagenes.length === 1 ? "Imagen" : "Imagenes"}</p>}
                  </label>
                </div>
              </div>
            </>
          )}
          <div className={styles.box}>
            <label>Nombre y apellido</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
            />
          </div>
          <div className={styles.box}>
            <label>Localidad</label>
            <input
              type="text"
              name="localidad"
              value={formData.localidad}
              onChange={handleChange}
            />
          </div>
          <div className={styles.box}>
            <label>Provincia / Departamento</label>
            <input
              type="text"
              name="provincia"
              value={formData.provincia}
              onChange={handleChange}
            />
          </div>
          <div className={styles.box}>
            <label>Teléfono</label>
            <input
              type="tel"
              name="telefono"
              value={formData.telefono}
              onChange={handleChange}
            />
          </div>
          <div className={styles.box}>
            <label>E-mail *</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
            />
          </div>
          {formData.selectedOption === "Recursos humanos" && (
            <div className={styles.box}>
              <label htmlFor="fileInput">Adjuntar CV</label>
              <div className={styles.customFile}>
                <label className={styles.customFileLabel}>
                  <input
                    type="file"
                    className={styles.customFileInput}
                    name="cv"
                    onChange={handleCvChange}
                  />
                  <p>
                    {formData.cv ? (
                      <>
                        Cargado correctamente{" "}
                        <span
                          style={{
                            color: "green",
                            fontSize: "20px",
                            position: "relative",
                            marginLeft: "5px",
                          }}
                        >
                          ✔
                        </span>
                      </>
                    ) : (
                      "Adjuntar"
                    )}
                  </p>
                </label>
              </div>
            </div>
          )}
          <div className={styles.box3}>
            <label>Mensaje *</label>
            <textarea
              rows="4"
              cols="50"
              name="message"
              value={formData.message}
              onChange={handleChange}
              style={{ resize: "none" }}
            ></textarea>
          </div>
          <div className={styles.ButtonContainer}>
            <button
              type="submit"
              disabled={isSubmitting || isSuccess}
              className={`${isSuccess ? styles.ButtonSuccess : ''} ${isSubmitting ? styles.ButtonSubmitting : ''}`}
              style={{ cursor: (isSubmitting || isSuccess) ? 'not-allowed' : 'pointer' }}
            >
              {isSubmitting ? <span className={styles.loader}></span> : isSuccess ? "Enviado" : "Enviar"}
            </button>
          </div>
        </form>
      </div>
    </section>
  );
};

export default ContactForm;
